<template>
  <div style="margin: 16px">
    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card
          :loading="loading"
          :title="$t('DASHBOARD.ANALYSIS.TOTAL-SALES')"
          :total="`￥ ${baseStatistics.orderAmount||0}`">
          <template
            slot="footer">{{ $t('DASHBOARD.ANALYSIS.DAY-SALES') }}
            <span>
            ￥ {{ baseStatistics.todayOrderAmount || 0 }} </span></template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card
          :loading="loading"
        :title="$t('DASHBOARD.ANALYSIS.VISITS')"
        :total="wechat.visitTotal">
          <template
            slot="footer">
            {{ $t('DASHBOARD.ANALYSIS.DAY-VISITS') }}<span>
            {{ wechat.visitUv || 0 }}</span>
          </template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card
          :loading="loading"
          :title="$t('DASHBOARD.ANALYSIS.PAYMENTS')"
          :total="baseStatistics.orderCount">
          <template slot="footer">
            {{ $t('DASHBOARD.ANALYSIS.CONVERSION-RATE') }} <span>
            {{
              (baseStatistics.orderUserCount /
                (wechat.visitTotal || 1) * 100).toFixed(1)
            }}%</span>
          </template>
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card
          :loading="loading"
          :title="$t('DASHBOARD.ANALYSIS.USERS')"
          :total="wechat.visitUv">
          <template slot="footer">
            {{ $t('DASHBOARD.ANALYSIS.DAILY-JOIN-USER') }} <span>{{ wechat.visitUvNew }}</span>
          </template>
        </chart-card>
      </a-col>
    </a-row>

    <a-card :loading="loading" :bordered="false" :body-style="{padding: '0'}">
      <div class="salesCard">
        <a-tabs
          default-active-key="SALES"
          size="large"
          :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">
          <div class="extra-wrapper" slot="tabBarExtraContent">
            <div class="extra-item">
              <a @click="setWeekScope">{{ $t('DASHBOARD.ANALYSIS.ALL-WEEK') }}</a>
              <a @click="setMonthScope">{{ $t('DASHBOARD.ANALYSIS.ALL-MONTH') }}</a>
              <a @click="setYearScope">{{ $t('DASHBOARD.ANALYSIS.ALL-YEAR') }}</a>
            </div>
            <a-range-picker
              v-model="searchForm.data.timeScope"
              :style="{width: '256px'}"
              @change="getOrderStatistics"/>
          </div>
          <a-tab-pane loading="true" :tab="$t('DASHBOARD.ANALYSIS.SALES')" key="SALES">
            <a-row>
              <a-col :span="24">
                <simple-chart :option="chart.salesOption" style="height: 300px;"></simple-chart>
              </a-col>
              <a-col :span="24">
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane loading="true" tab="订单数" key="ORDERS">
            <a-row>
              <a-col :span="24">
                <simple-chart :option="chart.orderQtyOption" style="height: 300px;"></simple-chart>
              </a-col>
              <a-col :span="24">
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane :tab="$t('DASHBOARD.ANALYSIS.VISITS')" key="VISITS">
            <a-row>
              <a-col :span="24">
                <simple-chart :option="chart.visitsOption" style="height: 300px;"></simple-chart>
              </a-col>
              <a-col :span="24">
              </a-col>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>
    <a-row :gutter="24" style="margin-top: 20px">
      <a-col :span="24">
        <a-card :title="$t('DASHBOARD.ANALYSIS.TOP10_GOODS')">
          <a-select
            mode="multiple"
            allowClear
            :filter-option="filterOption"
            style="width: 100%"
            v-model="skuQty.selectedIds"
            placeholder="Please select"
            @change="getPaidSkuQty"
          >
            <a-select-option v-for="item in skuQty.data" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <simple-chart :option="chart.top10Goods" style="height: 500px;"></simple-chart>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from 'moment';
import ChartCard from '@/components/charts/ChartCard.vue';
import {
  _baseStatistics,
  _monthStatistics,
  _paidOrderQtyStatistics,
  _paidOrderStatistics,
  _paidSkuQtyStatistics,
  _wechatStatistics,
  _wechatVisitStatistics,
} from '@/api/statisticsApi';

import SimpleChart from '@/components/SimpleChart.vue';

async function getOrderStatistics() {
  if (this.searchForm.data.timeScope.length === 0) {
    return;
  }
  const timeScope = this.searchForm.data.timeScope && this.searchForm.data.timeScope.length === 2
    ? this.searchForm.data.timeScope : [null, null];
  const startAt = moment(new Date(timeScope[0]));
  const endAt = moment(new Date(timeScope[1]));
  const amountMap = new Map();
  const visitMap = new Map();
  const orderQtyMap = new Map();

  const wechatVisitStatisticsResponse = await _wechatVisitStatistics({
    startAt: startAt
      .format('YYYY-MM-DD 00:00:00'),
    endAt: endAt
      .format('YYYY-MM-DD 23:59:59'),
  });

  wechatVisitStatisticsResponse.forEach((x) => {
    visitMap.set(moment(new Date(x.ref_date.substring(0, 4) + '-' + x.ref_date.substring(4, 6) + '-' + x.ref_date.substring(6, 8))).format('YYYY-MM-DD'), x.visit_pv);
  });

  const paidOrderStatisticsResponse = await _paidOrderStatistics({
    startAt: startAt
      .format('YYYY-MM-DD 00:00:00'),
    endAt: endAt
      .format('YYYY-MM-DD 23:59:59'),
  });
  paidOrderStatisticsResponse.forEach((x) => {
    amountMap.set(x.orderDate, x.totalAmount);
  });
  const paidOrderQtyStatisticsResponse = await _paidOrderQtyStatistics({
    startAt: startAt
      .format('YYYY-MM-DD 00:00:00'),
    endAt: endAt
      .format('YYYY-MM-DD 23:59:59'),
  });
  paidOrderQtyStatisticsResponse.forEach((x) => {
    orderQtyMap.set(x.orderDate, x.qty);
  });
  const days = endAt.diff(startAt, 'days');
  const dayArray = [];
  const amountArray = [];
  const wechatArray = [];
  const orderQtyArray = [];
  for (let i = 0; i <= days; i += 1) {
    const date = moment(new Date(startAt))
      .add(i, 'days')
      .format('YYYY-MM-DD');
    dayArray.push(date);
    amountArray.push(amountMap.get(date));
    wechatArray.push(visitMap.get(date));
    orderQtyArray.push(orderQtyMap.get(date));
  }
  this.chart.salesOption.xAxis.data = dayArray;
  this.chart.salesOption.series = [{
    data: amountArray,
    type: 'bar',
    label: {
      show: true,
      position: 'top',
    },
  }];
  this.chart.orderQtyOption.xAxis.data = dayArray;
  this.chart.orderQtyOption.series = [{
    data: orderQtyArray,
    type: 'bar',
    label: {
      show: true,
      position: 'top',
    },
  }];

  this.chart.visitsOption.xAxis.data = dayArray;
  this.chart.visitsOption.series = [{
    data: wechatArray,
    type: 'line',
    label: {
      show: true,
      position: 'top',
    },
  }];
}

async function getPaidSkuQty() {
  const data = this.skuQty.data
    .filter(x => (this.skuQty.selectedIds.length > 0
      ? this.skuQty.selectedIds.includes(x.id) : true));
  this.chart.top10Goods.series = [{
    data: data.map(x => (x.quantity)),
    type: 'bar',
    showSymbol: false,
    clip: true,
  }];

  this.chart.top10Goods.xAxis = [{
    data: data.map(x => (x.name)),
  }];
}

function setWeekScope() {
  const endAt = moment();
  const startAt = moment(new Date(endAt))
    .add(-1, 'week');
  this.searchForm.data.timeScope = [startAt, endAt];
  this.getOrderStatistics();
}

function setMonthScope() {
  const endAt = moment();
  const startAt = moment(new Date(endAt))
    .add(-1, 'month');
  this.searchForm.data.timeScope = [startAt, endAt];
  this.getOrderStatistics();
}

function setYearScope() {
  const endAt = moment();
  const startAt = moment(new Date(endAt))
    .add(-1, 'year');
  this.searchForm.data.timeScope = [startAt, endAt];
  this.getOrderStatistics();
}

export default {
  name: 'Home',
  components: {
    ChartCard,
    SimpleChart,
  },
  data() {
    return {
      loading: false,
      skuQty: {
        data: [],
        selectedIds: [],
      },
      dayStatistics: {
        orderAmount: 0,
        orderCount: 0,
        refundOrderAmount: 0,
        refundOrderCount: 0,
        unShipOrderCount: 0,
      },
      baseStatistics: {
        orderAmount: 0,
        todayOrderAmount: 0,
        orderCount: 0,
        refundOrderAmount: 0,
        refundOrderCount: 0,
        unShipOrderCount: 0,
        orderUserCount: 0,
      },
      monthStatistics: {
        monthOrderCount: 0,
        monthOrderAmount: 0,
        monthRefundOrderAmount: 0,
        monthRefundOrderCount: 0,
        monthUnShipOrderCount: 0,
      },
      wechat: {
        visitUv: 0,
        visitUvNew: 0,
        visitTotal: 0,
      },
      value: ['1'],
      searchForm: {
        data: {
          timeScope: [],
          type: 'SALES',
        },
      },
      chart: {
        salesOption: {
          title: {
            show: false,
          },
          color: ['#58afff'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
            },
          },
          grid: {
            top: 30,
            bottom: 30,
            left: 30,
            right: 30,
          },
          legend: {
            show: false,
            top: 0,
          },
          xAxis: {
            type: 'category',
            data: [],
            show: true,
            axisTick: {
              lineStyle: {
                color: 'rgb(128, 128, 128)',
              },
            },
          },
          yAxis: {
            type: 'value',
            show: false,
          },
          series: [{
            data: [],
            name: '',
            type: 'bar',
          }],
        },
        visitsOption: {
          title: {
            show: false,
          },
          color: ['#58afff'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
            },
          },
          grid: {
            top: 30,
            bottom: 30,
            left: 30,
            right: 30,
          },
          legend: {
            show: false,
            top: 0,
          },
          xAxis: {
            type: 'category',
            data: [],
            show: true,
          },
          yAxis: {
            type: 'value',
            show: false,
          },
          series: [{
            data: [],
            name: '',
            type: 'bar',
          }],
        },
        orderQtyOption: {
          title: {
            show: false,
          },
          color: ['#58afff'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
            },
          },
          grid: {
            top: 30,
            bottom: 30,
            left: 30,
            right: 30,
          },
          legend: {
            show: false,
            top: 0,
          },
          xAxis: {
            type: 'category',
            data: [],
            show: true,
            axisTick: {
              lineStyle: {
                color: 'rgb(128, 128, 128)',
              },
            },
          },
          yAxis: {
            type: 'value',
            show: false,
          },
          series: [{
            data: [],
            name: '',
            type: 'bar',
          }],
        },
        sellDataByCategoryOption: {
          legend: {
            top: 'bottom',
            show: false,
          },
          color: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4'],
          toolbox: {
            show: true,
            feature: {
              mark: { show: true },
              dataView: { show: true, readOnly: false },
              restore: { show: true },
              saveAsImage: { show: true },
            },
          },
          series: [
            {
              name: '面积模式',
              type: 'pie',
              radius: [25, 100],
              center: ['50%', '50%'],
              roseType: 'area',
              itemStyle: {
                borderRadius: 8,
              },
              data: [],
            },
          ],
        },
        top10Goods: {
          legend: {
            top: 'bottom',
          },
          visualMap: {
            top: 50,
            right: 10,
            pieces: [{
              gt: 0,
              lte: 20,
              color: '#5470c6',
            }, {
              gt: 30,
              lte: 40,
              color: '#91cc75',
            }, {
              gt: 40,
              lte: 60,
              color: '#fac858',
            }, {
              gt: 60,
              lte: 80,
              color: '#31a0e7',
            }, {
              gt: 80,
              lte: 100,
              color: '#73c0de',
            }, {
              gt: 100,
              lte: 120,
              color: '#3ba272',
            }, {
              gt: 120,
              lte: 140,
              color: '#9a60b4',
            }],
            outOfRange: {
              color: '#ff7070',
            },
          },
          grid: {
            top: 30,
            bottom: 80,
            left: 30,
            right: 30,
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
            },
          },
          dataZoom: [
            {
              show: true,
              realtime: true,
              startValue: 0,
              endValue: 9,
            },
          ],
          yAxis: {
            type: 'value',
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            data: [],
            splitLine: {
              show: false,
            },
            symbol: 'none',
          },
          xAxis: {
            type: 'category',
            splitLine: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              rotate: 30,
            },
          },
          series: [{
            data: [],
            type: 'bar',
            label: {
              show: true,
              position: 'top',
            },
            barMaxWidth: 20,
            showSymbol: false,
            clip: true,
          }],
        },
      },
    };
  },
  methods: {
    getOrderStatistics,
    setWeekScope,
    setMonthScope,
    setYearScope,
    getPaidSkuQty,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  async created() {
    this.setMonthScope();
    this.skuQty.data = await _paidSkuQtyStatistics({});
    // this.skuQty.selectedIds = this.skuQty.data.map(x => x.id);
    this.getPaidSkuQty();
    const baseStatisticsResponse = await _baseStatistics();
    this.baseStatistics = baseStatisticsResponse;
    this.chart.sellDataByCategoryOption.series = [
      {
        name: '',
        type: 'pie',
        radius: [25, 100],
        center: ['50%', '50%'],
        roseType: 'area',
        itemStyle: {
          borderRadius: 8,
        },
        data: baseStatisticsResponse.countByCategory.map(x => ({
          name: x.name,
          value: x.quantity,
        })),
      },
    ];
    const wechatStatisticsResponse = await _wechatStatistics({});
    this.wechat = {
      visitUv: wechatStatisticsResponse.monthlyRetainInfo.visitUv['0'],
      visitUvNew: wechatStatisticsResponse.monthlyRetainInfo.visitUvNew['0'],
      visitTotal: wechatStatisticsResponse.dailySummaryTrend[0].visitTotal,
    };

    this.monthStatistics = await _monthStatistics({});
  },
};
</script>

<style lang="less" scoped>
.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}

.antd-pro-pages-dashboard-analysis-twoColLayout {
  position: relative;
  display: flex;
  display: block;
  flex-flow: row wrap;
}

.antd-pro-pages-dashboard-analysis-salesCard {
  height: calc(100% - 24px);

  /deep/ .ant-card-head {
    position: relative;
  }
}

.dashboard-analysis-iconGroup {
  i {
    margin-left: 16px;
    color: rgba(0, 0, 0, .45);
    cursor: pointer;
    transition: color .32s;
    color: black;
  }
}

.analysis-salesTypeRadio {
  position: absolute;
  right: 54px;
  bottom: 12px;
}
</style>
